// extracted by mini-css-extract-plugin
module.exports = {"pageText":"PageFooter_pageText__YdcIS","pageLink":"PageFooter_pageLink__YT3wq"};